import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import language from './modules/language'
import dashboard from './modules/dashboard'
import chargers from './modules/chargers'
import media from './modules/media'
import partners from './modules/partners'
import users from './modules/users'
import sky from './modules/sky'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  modules: {
    auth,
    language,
    dashboard,
    chargers,
    media,
    partners,
    users,
    sky
  }
})
